import {
    VEHICLE_LIST,
    VEHICLE_LIST_SUCCESS,
    VEHICLE_LIST_ERROR,
    VEHICLE_PAGE_SET,
    VEHICLE_DETAIL,
    VEHICLE_DETAIL_SUCCESS,
    VEHICLE_DETAIL_ERROR,
    VEHICLE_VIEW_MODAL_SET,
    VEHICLE_ADD_MODAL_SET,
    VEHICLE_ADD,
    VEHICLE_ADD_SUCCESS,
    VEHICLE_ADD_ERROR,
    VEHICLE_ADD_CHANGE,
    VEHICLE_EDIT_MODAL_SET,
    VEHICLE_EDIT_SET,
    VEHICLE_EDIT_CHANGE,
    VEHICLE_UPDATE,
    VEHICLE_UPDATE_SUCCESS,
    VEHICLE_UPDATE_ERROR
} from '../actions';

const INIT_STATE = {
    loading: true,
    error: false,
    list: {
        page: { current: 1, rows: 10 },
        data: [],
        total_pages: 0,
        total_item: 0,
        first_page: 0,
        last_items: 0
    },
    detail: {
        data: {},
        loading: false
    },
    view: {
        modal: false
    },
    add: {
        modal: false,
        loading: false,
        id: null,
        data: {
            new: {
                id_vehicle_type: '',
                code: '',
                brand: '',
                model: '',
                color: ''
            }
        }
    },
    edit: {
        modal: false,
        loading: false,
        data: {}
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case VEHICLE_LIST:
            return { ...state, loading: true };
        case VEHICLE_LIST_SUCCESS:
            return { ...state, loading: false, list: { ...state.list, ...action.payload } };
        case VEHICLE_LIST_ERROR:
            return { ...state, loading: false, error: true };
        case VEHICLE_PAGE_SET:
            return { ...state, list: { ...state.list, page: { ...state.list.page, ...action.payload } } };
        case VEHICLE_DETAIL:
            return { ...state, detail: { ...state.detail, loading: true, data: {} } };
        case VEHICLE_DETAIL_SUCCESS:
            return { ...state, detail: { ...state.detail, loading: false, data: action.payload } };
        case VEHICLE_DETAIL_ERROR:
            return { ...state, detail: { ...state.detail, loading: false, data: {} } };
        case VEHICLE_VIEW_MODAL_SET:
            return { ...state, view: { ...state.view, modal: action.payload } };
        case VEHICLE_ADD_MODAL_SET:
            return { ...state, add: { ...state.add, modal: action.payload } };
        case VEHICLE_ADD:
            return { ...state, add: { ...state.add, loading: true } };
        case VEHICLE_ADD_SUCCESS:
            return { ...state, add: { ...state.add, loading: false, id: action.payload, data: { new: { id_vehicle_type: '', code: '', brand: '', model: '', color: '' } } } };
        case VEHICLE_ADD_ERROR:
            return { ...state, add: { ...state.add, loading: false } };
        case VEHICLE_ADD_CHANGE:
            return { ...state, add: { ...state.add, data: { new: { ...state.add.data.new, ...action.payload } } } };
        case VEHICLE_EDIT_MODAL_SET:
            return { ...state, edit: { ...state.edit, modal: action.payload } };
        case VEHICLE_EDIT_SET:
            return { ...state, edit: { ...state.edit, data: action.payload } };
        case VEHICLE_EDIT_CHANGE:
            return { ...state, edit: { ...state.edit, data: { ...state.edit.data, ...action.payload } } };
        case VEHICLE_UPDATE:
            return { ...state, edit: { ...state.edit, loading: true } };
        case VEHICLE_UPDATE_SUCCESS:
            return { ...state, edit: { ...state.edit, loading: false, modal: false } };
        case VEHICLE_UPDATE_ERROR:
            return { ...state, edit: { ...state.edit, loading: false } };
        default:
            return state;
    }
};
